import moment from "moment";
import {
  APPROVE_DATA_SORT,
  APPROVE_SET_QUERY,
  APPROVE_SET_DATES,
  APPROVE_SET_PAGE,
  APPROVE_SET_TAB,
  APPROVE_SET_APP_STATUSES,
  APPROVE_SET_BOOKING_STATUSES,
  SetApproveDatesActionI,
  SetApproveQueryActionI,
  SetApprovePageActionI,
  SetApproveTabActionI,
  SetApprovalStatusesActionI,
  SetBookingStatusesActionI,
  ApproveDataSortActionI,
} from "src/redux/actions/approve";
import {
  historyApprovalStatuses,
  historyBookingStatuses,
} from "src/services/approve";

export interface InitialApprovalState {
  endDate?: moment.Moment;
  page?: number;
  totalCount?: number;
  query?: string;
  selectedTab?: string;
  sortDirection?: string;
  sortColumn?: string;
  startDate?: moment.Moment;
  transferOptions?: null;
  approvalStatuses?: number[];
  bookingStatuses?: number[];
}

export const initialApprovalState: InitialApprovalState = {
  endDate: null,
  page: 1,
  totalCount: 0,
  query: "",
  selectedTab: "Queue",
  sortDirection: "descending",
  sortColumn: "travelDateFormatted",
  startDate: null,
  transferOptions: null,
  approvalStatuses: historyApprovalStatuses,
  bookingStatuses: historyBookingStatuses,
};

export interface ApprovalStateI {
  ids: {
    [key: string]: InitialApprovalState;
  };
}

const itinState: ApprovalStateI = { ids: {} };

export type ApprovalActionI =
  | SetApproveQueryActionI
  | SetApproveDatesActionI
  | SetApprovePageActionI
  | SetApproveTabActionI
  | SetApprovalStatusesActionI
  | SetBookingStatusesActionI
  | ApproveDataSortActionI;

const approve = (
  state = itinState,
  action: ApprovalActionI,
): ApprovalStateI => {
  const featureSet = state.ids[action.id] || { ...initialApprovalState };

  switch (action.type) {
    case APPROVE_DATA_SORT:
      return {
        ...state,
        ids: {
          ...state.ids,
          [action.id]: {
            ...featureSet,
            sortColumn: action.sortColumn,
            sortDirection: action.sortDirection,
          },
        },
      };
    case APPROVE_SET_QUERY:
      return {
        ...state,
        ids: {
          ...state.ids,
          [action.id]: {
            ...featureSet,
            page: 1,
            query: action.query,
          },
        },
      };
    case APPROVE_SET_TAB:
      return {
        ...state,
        ids: {
          ...state.ids,
          [action.id]: {
            ...featureSet,
            page: 1,
            selectedTab: action.selectedTab,
          },
        },
      };
    case APPROVE_SET_DATES:
      return {
        ...state,
        ids: {
          ...state.ids,
          [action.id]: {
            ...featureSet,
            page: 1,
            startDate: action.startDate,
            endDate: action.endDate,
          },
        },
      };
    case APPROVE_SET_PAGE:
      return {
        ...state,
        ids: {
          ...state.ids,
          [action.id]: {
            ...featureSet,
            page: action.page,
          },
        },
      };
    case APPROVE_SET_APP_STATUSES:
      return {
        ...state,
        ids: {
          ...state.ids,
          [action.id]: {
            ...featureSet,
            approvalStatuses: action.approvalStatuses,
            page: 1,
          },
        },
      };
    case APPROVE_SET_BOOKING_STATUSES:
      return {
        ...state,
        ids: {
          ...state.ids,
          [action.id]: {
            ...featureSet,
            bookingStatuses: action.bookingStatuses,
            page: 1,
          },
        },
      };
    default:
      return state;
  }
};

export default approve;
